import amplitude from 'amplitude-js'
import { AssistButtonAction, AssistButtonDeferredAction, AssistReason, AssistRenderType } from '../types'

const instance = amplitude.getInstance()
instance.init('42ab2afff601a01ab9aecf0c664e700c')

interface AnalyticsProps {
  action?: AssistButtonAction
  reason?: AssistReason
  deferredAction?: AssistButtonDeferredAction
  message?: string
  renderType: AssistRenderType
  source: string
  requestStatus: string
  dspName: string
  requestId: number
}

const sendAnalytics = ({
  action,
  reason,
  deferredAction,
  requestId,
  requestStatus,
  dspName,
  source,
  renderType,
}: AnalyticsProps) => {
  try {
    const eventData: any = {
      REQUEST_ID: requestId,
      REQUEST_STATUS: requestStatus,
      DSP_NAME: dspName,
      SOURCE: source,
      ACTION: action,
      // OPTION: reason,
      // MESSAGE: message,
      // deferredAction,
    }

    let eventName
    switch (renderType) {
      case 'button':
        eventName = 'ASSIST_CLICK_FIRST_TIME'
        break
      case 'popup_help':
        eventName = 'OPTIONSPOP_OPTION_CHOOSE'
        eventData.OPTION = action
        if (deferredAction) {
          eventData.OPTION += `_${deferredAction}`
        }
        break
      case 'popup_reason':
        eventName = 'INCIDENTSPOP_SUBMIT_CLICK'
        eventData.OPTION = reason
        break
      default:
        eventName = `COUNTDOWNPOP_${action.toUpperCase()}_CLICK`
        break
    }

    instance.logEventWithTimestamp(eventName, eventData, Date.now())
  } catch (error) {
    console.log(error)
  }
}

export { sendAnalytics }

export default instance
